module.exports = __webpack_public_path__ + "img/hourglass.c2d940e1.png";